import axios from 'axios';
import moment from 'moment';
import { getSapAuthToken } from 'utils/getSAPAuthToken';

export default class Subscription {
  subscriptionId: any;
  invoiceID?: number;
  requestPath: any;
  requestParams: any;

  constructor(subscriptionId, invoiceID?: number) {
    this.subscriptionId = subscriptionId;
    this.invoiceID = invoiceID;

    this.requestPath = '/Subscription_APIs/subscriptions/';
    this.requestParams = '?expand=snapshots.items.priceDetails';
  }

  async fecthJWTToken() {
    try {
      const response = await getSapAuthToken().then(response => {
        return response.body?.access_token;
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchJWTType() {
    try {
      const response = await getSapAuthToken().then(response => {
        return response.body?.token_type;
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchCustomerNumber() {
    try {
      const token = await this.fecthJWTToken().then(response => {
        return response;
      });
      const type = await this.fetchJWTType().then(response => {
        return response;
      });
      const url = `${process.env.REACT_APP_SAP_SB_PROXY_API_URL}${this.requestPath}${this.subscriptionId}${this.requestParams}`;
      const response = await axios
        .get(url, {
          headers: {
            Authorization: `${type} ${token}`,
          },
        })
        .then(response => {
          return response.data['customer']['id'];
        });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchDROrderDetails() {
    try {
      const url = `https://api.digitalriver.com/orders/${this.invoiceID}`;
      const defaultHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_DIGITAL_RIVER_AUTH_TOKEN}`,
      };
      const response = await axios
        .get(url, {
          headers: defaultHeaders,
        })
        .then(response => {
          return response.data;
        });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchChargeableQuantity() {
    try {
      const token = await this.fecthJWTToken().then(response => {
        return response;
      });
      const type = await this.fetchJWTType().then(response => {
        return response;
      });
      const url = `${process.env.REACT_APP_SAP_SB_PROXY_API_URL}${this.requestPath}${this.subscriptionId}${this.requestParams}`;
      const response = await axios
        .get(url, {
          headers: {
            Authorization: `${type} ${token}`,
          },
        })
        .then(response => {
          let firstDate = '';
          let nextDate = '';
          let dates = response.data['snapshots'];
          dates.map(item => {
            if (moment(item.effectiveDate).isBefore(moment())) {
              firstDate = item.effectiveDate;
            }
            if (nextDate !== '' || nextDate !== null) {
              if (moment(nextDate).isAfter(firstDate)) {
                firstDate = nextDate;
              }
            }
            nextDate = firstDate;
          });
          dates = dates.filter(snapshot => {
            return snapshot.effectiveDate === firstDate;
          });
          return dates[0]['items'][0]['subscriptionParameters'][0]['value'];
        });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchBillingCycleTime(billingDate) {
    try {
      const token = await this.fecthJWTToken().then(response => {
        return response;
      });
      const type = await this.fetchJWTType().then(response => {
        return response;
      });
      const url = `${process.env.REACT_APP_SAP_SB_PROXY_API_URL}${this.requestPath}${this.subscriptionId}${this.requestParams}`;
      const response = await axios
        .get(url, {
          headers: {
            Authorization: `${type} ${token}`,
          },
        })
        .then(response => {
          const billTime = response.data['billingCycleReferenceDate'].split(
            'T'
          );

          return `${billingDate}T${billTime[1]}`;
        });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchPaymentPlan(validAt) {
    if (validAt) {
      try {
        const pricingParameters = {
          amount: 0,
          currencyCode: 'USD',
        };
        const token = await this.fecthJWTToken().then(response => {
          return response;
        });
        const type = await this.fetchJWTType().then(response => {
          return response;
        });
        const url = `${process.env.REACT_APP_SAP_SB_PROXY_API_URL}${this.requestPath}${this.subscriptionId}${this.requestParams}&validAt=${validAt}`;
        const response = await axios
          .get(url, {
            headers: {
              Authorization: `${type} ${token}`,
            },
          })
          .then(response => {
            return response.data['snapshots'][0]['items'][0]['priceDetails'][
              'effective'
            ]['prices'][0]['pricingElements'][0]['pricingFields'][0][
              'priceConditionValue'
            ]['rows'][0]['monetaryAmount']['amount'];
          });
        pricingParameters['amount'] = response;
        return pricingParameters;
      } catch (error) {
        console.log(error);
      }
    }
  }
}
